/* eslint-disable no-underscore-dangle */
import { Component, OnInit } from '@angular/core';
import { DeployParams } from 'src/app/deployParams';
import { ICustomNotification } from 'src/app/models/notification/customNotification';
import { ErrorLevel, ErrorType, PlatformHeadrId, RestrictionEntityTypes, SiteViewConfiguration } from 'src/app/models/enums';
import { NotificationService } from 'src/app/services/notification.service';
import { CashOutService } from 'src/app/services/cash-out.service';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { TicketService } from 'src/app/services/ticket.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { environment } from 'src/environments/environment';

// import { TOOfflineBet } from '../model/ticket-validation/offline-bets';
// import { ErrorDialogEventModel } from '../model/ticket-validation/error-dialog-event';
// import { CashOutService } from '../shared/cashOut.service';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.less'],
})
export class NotificationDialogComponent {

  showNotificationDialog = false;
  customNotification: ICustomNotification;
  showReloadButton = false;
  showCloseButton = true;
  showConfirmButtons = false;
  showSpinner = false;
  errorLevelEnum = ErrorLevel;
  errorType = ErrorType;
  viewConfigurations = ViewConfigurations;
  showMyTicketsButton = false;
  notification: ICustomNotification;
  timeToAccept = 300;
  interval;
  showLinkButton = false;
  scroll = 0;

  constructor(
    protected _notificationService: NotificationService,
    protected _cashOutService: CashOutService,
    protected ticketService: TicketService,
    protected router: Router,
    protected authentificationService: AuthenticationService) {
    _notificationService.notificationDialogData$.subscribe(dt => {
      this.notification = dt;
      this.processData(dt);
    });
    _notificationService.closeNotificationDialog$.subscribe(cl => this.closeNotificationDialog());
    this.customNotification = {
      message: 'Poruka',
      title: 'Naslov',
      offlineBets: [{
        code: '1021',
        name: '1',
        sbv: '13',
        outcome: '1.13',
        betType: 'Ukupno golova',
        offlineBetType: 'offlineBetType',
      }],
      restictedItems: [{
        restrictedItemOne: {
          entityName: 'entityName1',
          entityId: 12,
          entityType: RestrictionEntityTypes.Sport
        },
        restrictedItemTwo: {
          entityName: 'entityName2',
          entityId: 13,
          entityType: RestrictionEntityTypes.Region
        }
      }],
      errorLevel: ErrorLevel.Notification,
      errorType: ErrorType.Warning,
      ticket: null,
      link: null
    };
  }

  private eventListener = (e) => {
    // console.log(111);
    // This is the F1 key code, but NOT with SHIFT/CTRL/ALT
    const keyCode = e.keyCode || e.which;
    if (keyCode === 27 || e.key === 'ESCAPE' || keyCode === 13 || e.key === 'NumpadEnter' || e.key === 'Enter') {
      // prevent code starts here:
      // this.removeDefaultFunction(e);
      // this.removeAllTicketItems();
      if (document.querySelectorAll('.ticket-option .btn')[0]) {
        (document.querySelectorAll('.ticket-option .btn')[0] as HTMLInputElement).click();
      } else {
        this.enableParentScroll();
      }
    }
  };

  startAcceptTimer() {
    this.interval = setInterval(() => {
      if (this.timeToAccept > 1) {
        this.timeToAccept--;
      }
    }, 1000);
  }

  resetAcceptTimer() {
    clearInterval(this.interval);
    this.timeToAccept = 300;
  }

  closeNotificationDialog(): void {
    this.showNotificationDialog = false;
    this.enableParentScroll();
    window.removeEventListener('keydown', this.eventListener, false);
  }

  openMyTickets(): void {
    this.showNotificationDialog = false;
    this.enableParentScroll();

    this.ticketService.openMyTicket();
  }


  reloadPage(): void {
      parent.location.reload();
      if (window.parent) {
        window.parent.postMessage({ reloadPage: true }, environment.postMessageURL);
      }
  }

  processData(notification: ICustomNotification) {
    this.resetAcceptTimer();
    this.showSpinner = false;
    this.customNotification = notification;
    this.showMyTicketsButton = false;

    if (notification.errorLevel === ErrorLevel.Fatal) {
      this.showReloadButton = true;
      this.showConfirmButtons = false;
    }


    if (notification.errorType === ErrorType.Authorization) {
      this.showConfirmButtons = false;
      this.showCloseButton = false;
      this.showSpinner = true;

      this.startAcceptTimer();

    } else {
      this.showConfirmButtons = false;
      this.showCloseButton = true;

      if (notification.errorType === ErrorType.CloseDialog || notification.errorType === ErrorType.SucssefulyPlayedTicket) {
        this._notificationService.closeConfirmTicketDialog();
      }

    }

    if (notification.errorType === ErrorType.SucssefulyPlayedTicket) {
      this.showMyTicketsButton = true;
    }

    if (notification.errorType === ErrorType.Reload) {
      this.showCloseButton = true;
      this.showReloadButton = true;
      this.showConfirmButtons = false;
      this.showLinkButton = false;
    }

    if (notification.errorType === ErrorType.CasheOutChange || notification.errorType === ErrorType.TicketPlaceBetOddChanged) {
      this.showCloseButton = false;
      this.showReloadButton = false;
      this.showConfirmButtons = true;
      this.showLinkButton = false;
    }

    if (notification.link !== undefined) {
      this.showCloseButton = false;
      this.showLinkButton = true;
      this.showConfirmButtons = false;
      this.showReloadButton = false;
    }

    this.showNotificationDialog = true;

    const interval = setInterval(() => { this.setDialogPosition(interval); }, 100);
    window.addEventListener('keydown', this.eventListener);

  }

  changeLink(link: string) {
    if (link) {
      this.router.navigate([link]);
    }
    // parent.location.reload();
    // this.enableParentScroll();
    // this.showNotificationDialog = false;
    this.closeNotificationDialog();
  }

  acceptButtonClick() {
    if (this.notification.errorType === ErrorType.TicketPlaceBetOddChanged) {
      this.ticketService.acceptOddsChangedAfterAddingToTicket();
      this.closeNotificationDialog();
    } else {
      this.sellTicket();
    }
  }

  setDialogPosition(interval) {
    if (document.getElementById('notificationDialog') === null) { return; }
    const notificationDialog = document.getElementById('notificationDialog');
    const scrollTop = 0;
    const windowHeight = window.parent.innerHeight;

    // console.log('notificationDialog ' + notificationDialog.offsetHeight);
    // console.log('windowHeight ' + windowHeight);
    const top = scrollTop + (windowHeight - notificationDialog.offsetHeight) / 2;
    notificationDialog.style.transform = 'translate(0px, ' + top + 'px)';

    this.disableParentScroll();

    setTimeout(() => {
      notificationDialog.style.opacity = '1';
      notificationDialog.style.transition = 'none';
    }, 200);

    clearInterval(interval);
  }

  disableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'hidden';

    // if (document.body.offsetHeight > window.innerHeight) {
    //   this.scroll = document.body.offsetHeight - window.innerHeight;
    //   window.parent.document.documentElement.classList.add('disable-scroll');
    //   window.parent.document.documentElement.style.top = - this.scroll + 'px';
    // } else {
    //   window.parent.document.documentElement.style.overflow = 'hidden';
    // }
  }

  enableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'auto';

    // if (this.scroll > 0) {
    //   document.getElementsByTagName('html')[0].classList.remove('disable-scroll');
    //   window.parent.scroll(0, this.scroll);
    // }
    // window.parent.document.documentElement.removeAttribute('style');
  }

  sellTicket() {
    this.closeNotificationDialog();
    this._cashOutService.sellBet(this.customNotification.ticket, !!this.authentificationService.loggedAffiliate);
  }

}
